"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeEmploymentAuthorization = void 0;
const employment_authorization_factory_1 = require("./employment-authorization.factory");
function fakeEmploymentAuthorization(count) {
    return new employment_authorization_factory_1.EmploymentAuthorizationFactory().listMocks(count);
}
exports.fakeEmploymentAuthorization = fakeEmploymentAuthorization;
